import React, { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import {
  Dashboard,
  Users,
  AllUsers,
  Affiliates,
  Corporates,
  Schools,
  Payout,
  Ticket,
  AllAdmins,
  AllAdminLevels,
} from "./pages";
import AppLayout from "./layouts/app_Layout";
import ErrorBoundary from "./ErrorBoundary";
import Loading from "./components/Loading";
import TicketPage from "./pages/tickets/components/TicketPage";
import RaiseTicketForm from "./pages/tickets/components/RaiseTicket";
import OtpScreen from "./acquisition/verify_mail/otp";
import NotFoundPage from "./pages/404";
import Login from "./acquisition/login";
import ProfileScreen from "./pages/profile";
import AdminManagement from "./pages/generate_admin";
import ThirdPartyRequestsPage from "./pages/thirdparty-requests";
import RequestJobProgressView from "./pages/thirdparty-requests/RequestJobProgressView";
import SchoolAIPage from "./pages/school-ai";
import CreateSchoolPage from "./pages/school-ai/create";
import ResolveTicketPage from "./pages/resolve-ticket";
import SchoolPaymentLinksPage from "./pages/school-payment-links";
const WaecImportPage = React.lazy(() => import("./pages/waec-import"));
const WaecPracticePage = React.lazy(() => import("./pages/waec-practice"));
const HelpyDatasetImportPage = React.lazy(() => import("./pages/helpy-dataset-import"));
const SystemAppAdminsPage = React.lazy(() => import("./pages/system-app-admins"));
const EmailMarketingPage = React.lazy(() => import("./pages/email-marketing"));
const TenantDomainsPage = React.lazy(() => import("./pages/tenant-domains"));
const ClasshubPricingPage = React.lazy(() => import("./pages/classhub-pricing"));
import CreateSchoolPaymentLinkPage from "./pages/school-payment-links/create";
import SchoolPaymentLinkDetailsPage from "./pages/school-payment-links/details";
const ResourcesPage = React.lazy(() => import("./pages/resources"));
const UploadResourcePage = React.lazy(() => import("./pages/resources/pages/upload_resource"));

const AppRouter = createBrowserRouter([
  {
    path: "home",
    element: (
      <Suspense fallback={<Loading />}>
        <AppLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" replace />,
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "permission",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
            <AdminManagement />,
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "third-party-requests",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <ThirdPartyRequestsPage />,
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "third-party-requests/progress/:jobId",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <RequestJobProgressView />,
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "school-ai",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <SchoolAIPage />
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "school-ai/create",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <CreateSchoolPage />
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "school-payment-links",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <SchoolPaymentLinksPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "system-app-admins",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <SystemAppAdminsPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "waec-import",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <WaecImportPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "waec-practice",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <WaecPracticePage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "helpy-dataset-import",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <HelpyDatasetImportPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "school-payment-links/create",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <CreateSchoolPaymentLinkPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "school-payment-links/:id",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <SchoolPaymentLinkDetailsPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "email-marketing",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <EmailMarketingPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "tenant-domains",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <TenantDomainsPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "classhub-pricing",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <ClasshubPricingPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "resolve-ticket",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <ResolveTicketPage />
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "all-permissions",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
            <AllAdminLevels />,
            </ErrorBoundary>
          </Suspense>
        ),       
      },
      {
        path: "users",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Users />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "all-users",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <AllUsers />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "admins",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <AllAdmins />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "affiliates",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Affiliates />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "corporates",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Corporates />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "resources",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <ResourcesPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "upload-resources",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <UploadResourcePage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "schools",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Schools />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "payout",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Payout />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "ticket",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <Ticket />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "profile",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <ProfileScreen />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "ticket-details/:id",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <TicketPage />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "raise-ticket",
        element: (
          <Suspense fallback={<Loading />}>
            <ErrorBoundary>
              <RaiseTicketForm />
            </ErrorBoundary>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/",
    element: <Navigate to="/auth" replace />,
  },
  {
    path: "/auth",
    element: <Login />,
    errorElement: <NotFoundPage />,
   
  },
  {
    path: "/verify-otp",
    element: <OtpScreen/>,
    errorElement: <NotFoundPage />,
   
  },
]);

export default AppRouter;
